import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames } from "../../../utils/helpers";
import { useIsomorphicLayoutEffect } from "../../../hooks/useIsomorphicLayoutEffect";
import { useFlyoutContext } from './Flyout.context';
import s from './Flyout.module.css';
import { PortalProvider as Portal } from "../portal";
export const FlyoutContent = (props) => {
    const { children, className, attributes, animated = true } = props;
    const { flyout, id, flyoutElRef, handleTransitionEnd, triggerType, handleMouseEnter, handleMouseLeave, contentGap, contentClassName, contentAttributes, trapFocusMode, } = useFlyoutContext();
    const { styles, status, position } = flyout;
    const updatedStyles = Object.assign(Object.assign({}, styles), { height: 'auto' });
    const [mounted, setMounted] = React.useState(false);
    useIsomorphicLayoutEffect(() => {
        setMounted(true);
    }, []);
    if (status === 'idle' || !mounted)
        return null;
    const contentClassNames = classNames(s.content, status === 'visible' && s['--visible'], 
    // Animate after correct position has been assigned
    ['visible', 'hidden'].includes(status) && s['--animated'], position && s[`--position-${position}`]);
    // className is applied to inner element because it has the transform and is treated like a real root element
    const innerClassNames = classNames(s.inner, animated && s['--animated'], className, contentClassName);
    let role;
    if (triggerType === 'hover') {
        role = 'tooltip';
    }
    else if (trapFocusMode === 'dialog') {
        role = 'dialog';
    }
    const content = (_jsx("div", { className: contentClassNames, style: Object.assign(Object.assign({}, updatedStyles), { '--st-flyout-gap': contentGap }), ref: flyoutElRef, id: id, role: role, "aria-modal": triggerType === 'click', onTransitionEnd: handleTransitionEnd, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: _jsx("div", Object.assign({}, attributes, { style: contentAttributes === null || contentAttributes === void 0 ? void 0 : contentAttributes.style, className: innerClassNames, children: children })) }));
    return _jsx(Portal, { children: content });
};
